
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__like_finger",
  "use": "icon__like_finger-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon__like_finger\"><path d=\"M8.086 1.25a.622.622 0 0 0-.586.625v1.094c0 1.504-.41 2.602-.742 3.281H1.25V17.5h13.36c.893 0 1.68-.61 1.874-1.48 0-.014.005-.034.005-.048l1.006-7.505-.015.058c.26-1.167-.673-2.275-1.87-2.275h-4.36V4.062c0-1.396-.86-2.236-1.64-2.548-.782-.318-1.524-.264-1.524-.264zm.664 1.348c.166.024.205-.005.39.068.47.195.86.45.86 1.397v2.812c0 .347.278.625.625.625h4.985c.45 0 .738.356.655.752l-.015.054-.991 7.45a.652.652 0 0 1-.65.494H7.5V7.524c.283-.434 1.25-2.1 1.25-4.555v-.371zM2.5 7.5h3.75v8.75H2.5V7.5zm1.875 6.25a.623.623 0 0 0-.625.625c0 .347.278.625.625.625A.623.623 0 0 0 5 14.375a.623.623 0 0 0-.625-.625z\" fill=\"currentColor\" /></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconLikeFingerIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__like_finger" {...restProps} />
    })
  